export const trySpeakerId = [
  'evt029_Iv_001',
  'evt029_Iv_002',
  'evt029_Iv_003',
  'evt029_sp_001',
  'evt029_sp_002',
  'evt029_sp_003',
  'evt029_sp_004',
  'evt029_sp_005',
  'evt029_sp_006',
  'evt029_sp_007',
  'evt029_sp_008',
  'evt029_sp_010',
  'evt029_sp_013',
  'evt029_sp_015',
  'evt029_sp_016',
  'evt029_sp_017',
  'evt029_sp_018',
  'evt029_sp_019',
  'evt029_sp_020',
  'evt029_sp_021',
  'evt029_sp_022',
  'evt029_sp_023',
  'evt029_sp_024',
  'evt029_sp_025',
  'evt029_sp_026',
  'evt029_sp_027',
  'evt029_sp_028',
  'evt029_sp_029',
  'evt029_sp_030',
  'evt029_sp_032',
  'evt029_sp_033',
  'evt029_sp_034',
  'evt029_sp_035',
  'evt029_sp_036',
  'evt029_sp_037',
  'evt029_sp_038',
  'evt029_sp_040',
  'evt029_sp_041',
  'evt029_sp_042',
  'evt029_sp_043',
  'evt029_sp_044',
  'evt029_sp_045',
  'evt029_sp_046',
  'evt029_sp_047',
  'evt029_sp_048',
  'evt029_sp_049',
  'evt029_sp_050',
  'evt029_sp_051',
  'evt029_sp_052',
  'evt029_sp_053',
  'evt029_sp_054',
  'evt029_sp_055',
  'evt029_sp_056',
  'evt029_sp_057',
  'evt029_sp_058',
  'evt029_sp_059',
  'evt029_sp_060',
  'evt029_sp_061',
  'evt029_sp_062',
  'evt029_sp_063',
  'evt029_sp_064',
  'evt029_sp_065',
  'evt029_sp_066',
  'evt029_sp_067',
  'evt029_sp_068',
  'evt029_sp_069',
  'evt029_sp_070',
  'evt029_sp_071',
  'evt029_sp_073',
  'evt029_sp_074',
  'evt029_sp_075',
  'evt029_sp_076',
  'evt029_sp_077',
  'evt029_sp_078',
  'evt029_sp_079',
];

export const tryKoreaSpeakerId = ['evt029_ksp_180', 'evt029_ksp_213'];

export const tryCvSpeakerId = [
  'evt029_Iv_001',
  'evt029_Iv_002',
  'evt029_Iv_003',
  'evt029_sp_002',
  'evt029_sp_005',
  'evt029_sp_007',
  'evt029_sp_015',
  'evt029_sp_018',
  'evt029_sp_021',
  'evt029_sp_022',
  'evt029_sp_023',
  'evt029_sp_026',
  'evt029_sp_030',
  'evt029_sp_032',
  'evt029_sp_037',
  'evt029_sp_040',
  'evt029_sp_043',
  'evt029_sp_044',
  'evt029_sp_045',
  'evt029_sp_046',
  'evt029_sp_047',
  'evt029_sp_051',
  'evt029_sp_052',
  'evt029_sp_054',
  'evt029_sp_056',
  'evt029_sp_061',
  'evt029_sp_065',
  'evt029_sp_066',
  'evt029_sp_067',
  'evt029_sp_068',
  'evt029_sp_073',
  'evt029_sp_075',
  'evt029_sp_078',
];

export const InvirtedSpeakers = [
  {
    id: 'evt120_Iv_001',
    name: 'David H. Song',
    affiliation: 'MedStar Georgetown<br/>University Hospital',
    country: 'USA',
    image: 'evt_120_is_1_02.png',
    cvfile: 'David+H.+Song_CV.pdf',
    type: 'Songbaek Speaker',
    color: '#aacb3c',
  },
  {
    id: 'evt120_Iv_002',
    name: 'Steve R. Cohen',
    affiliation: 'FACES+Plastic Surgery,<br/>Skin and Laser Center',
    country: 'USA',
    image: 'evt_120_is_2.png',
    cvfile: 'Steve+R.+Cohen_CV.pdf',
    type: 'Invited Speaker',
    color: '#237a9d',
  },
  {
    id: 'evt029_Iv_003',
    name: 'Phillip Blondeel',
    // affiliation: 'Gent University<br/>Hospital',
    affiliation: 'Ghent University',
    country: 'Belgium',
    image: 'evt_120_is_3_02.png',
    cvfile: 'Phillip+BLONDEEL_CV.pdf',
    type: 'Keynote Speaker',
    color: '#3f8d98',
  },
];
